const REISEGIGANTEN_AFFILIATE_IDS: Readonly<string[]> = [
  'RGGSM001',
  'RGGREST001',
  'RGGAFB001',
  'RGGVii001',
];

export function isReisegiganten(affiliateId: string | undefined): boolean {
  if (!affiliateId) {
    return false;
  }
  return REISEGIGANTEN_AFFILIATE_IDS.includes(affiliateId);
}
